import { useEffect } from "react";
import styles from "./styles.module.css";

export const Drawer = ({ isActive, handleClick }) => {
  useEffect(() => {
    const bodyElement = document?.querySelector("body");

    if (!bodyElement) return;

    if (isActive) {
      if (!bodyElement.classList.contains("aiiro-disable-scroll"))
        bodyElement.classList.add("aiiro-disable-scroll");
    } else {
      if (bodyElement.classList.contains("aiiro-disable-scroll"))
        bodyElement.classList.remove("aiiro-disable-scroll");
    }
  }, [isActive]);

  return (
    <div
      className={`${styles.drawer}${isActive ? ` ${styles.drawerActive}` : ""}`}
      onClick={handleClick}
    />
  );
};
